// MOCK: data fixa de protótipo. Em produção, usar new Date().
export const TODAY = new Date(2026, 2, 17);

export function isTransactionActive(lastTransaction: string): boolean {
  if (lastTransaction === '—') return false;
  const [datePart] = lastTransaction.split(' ');
  const [day, month, year] = datePart.split('/').map(Number);
  const txDate = new Date(year, month - 1, day);
  const diffDays = (TODAY.getTime() - txDate.getTime()) / (1000 * 60 * 60 * 24);
  return diffDays < 15;
}
